import { hasElements } from "Utils/Array";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { selectSelectedOrActiveProjects } from "Store/Selectors/Projects";
import { IUseSelectedProjects } from "./IUseSelectedProjects";

export function useSelectedProjects(): IUseSelectedProjects {
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  const selectedProjectsCount = selectedProjects?.length ?? 0;

  const hasNextProject = index + 1 < selectedProjectsCount;
  const onNextProject = useCallback(() => {
    setIndex(index + 1);
    if (selectedProjectsCount > 0) {
      setProgress((index + 1) / selectedProjectsCount);
    }
  }, [index, selectedProjectsCount]);
  const isLastProject = index + 1 === selectedProjectsCount;

  const project = hasElements(selectedProjects) ? selectedProjects[index] : null;

  return {
    project,
    progress,
    isLastProject,
    isMultiProject: selectedProjectsCount > 1,
    onNextProject: hasNextProject ? onNextProject : null
  };
}
